import { render, staticRenderFns } from "./accessRecord.vue?vue&type=template&id=009d8402&scoped=true&"
import script from "./accessRecord.vue?vue&type=script&lang=js&"
export * from "./accessRecord.vue?vue&type=script&lang=js&"
import style0 from "./accessRecord.vue?vue&type=style&index=0&id=009d8402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d8402",
  null
  
)

export default component.exports